import React from 'react';
import RadioButton from "../RadioButton";
import { Trans, useLingui } from '@lingui/react/macro';

function FormLockBase(props) {
    const {t} = useLingui();
    return (
        <>
            <h1>
                {props.isMedicalMobilityPage ? (
                    <Trans id="m_and_m_info_completed">Medical and Mobility information completed</Trans>
                ) : (
                    <Trans id="travel_info_completed">Travel information completed</Trans>
                )}
            </h1>
            <div className="text-lg text-grey-darker">
                <Trans id="lock_form_base_text">
                    <p>Thank you for answering all our pre-travel questions.</p>
                    <p>You can lock your information so other members of your travel party won’t be able to see what you’ve submitted.</p>
                </Trans>
            </div>

            <div className="mt-4">
                <div className="text-lg text-grey-darker">
                    <Trans id="do_you_lock_your_info">Do you wish to lock your information?</Trans>
                </div>
                <div className="mt-4">
                    <RadioButton
                        label={t({id: "Yes"})}
                        _onChange={() => props.setLock(true)}
                        isSelected={props.lock === true}
                    />
                </div>
                <div className="mt-4">
                    <RadioButton
                        label={t({id: "no"})}
                        _onChange={() => props.setLock(false)}
                        isSelected={props.lock === false}
                    />
                </div>
            </div>
        </>
    );
}

export default FormLockBase;